import { render } from "./facebookRed.vue?vue&type=template&id=54a2768e"
import script from "./facebookRed.vue?vue&type=script&lang=js"
export * from "./facebookRed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__